.FAQ {
  max-width: var(--brand-FAQ-maxWidth-list);
  margin: 0 auto;
}

.FAQ--variant-gridline {
  padding-block-end: var(--base-size-40);
  border-block-end: var(--brand-color-border-muted) var(--brand-borderWidth-thin) solid;
  max-width: 100%;
}

.FAQ__content-wrapper--gridline {
  padding-inline: var(--base-size-20);
  max-width: var(--brand-FAQ-maxWidth-list);
  margin: 0 auto;
}

.FAQ__heading-wrapper--gridline {
  padding-inline: var(--base-size-20);
  border-block-end: var(--brand-color-border-muted) var(--brand-borderWidth-thin) solid;
  margin-block-end: var(--base-size-40);
}

.FAQ__heading {
  color: var(--brand-FAQ-color-heading);
  margin-bottom: var(--brand-FAQ-heading-marginBottom);
}

.FAQ__subheading {
  margin-bottom: var(--base-size-16);
  color: var(--brand-color-text-muted);
  text-transform: uppercase;
  font-size: var(--brand-text-size-100);
  line-height: var(--brand-text-lineHeight-100);
}

.FAQ__heading--start {
  text-align: left;
}

.FAQ__heading--center {
  text-align: center;
  max-width: 18ch;
  margin-left: auto;
  margin-right: auto;
}

.FAQ__heading--large {
  /*Visual appearance as a h2*/
  font-weight: var(--brand-text-weight-normal);
  font-size: var(--brand-text-size-800);
  line-height: var(--brand-text-lineHeight-800);
  letter-spacing: var(--brand-text-letterSpacing-800);
}

.FAQ details + .FAQ__subheading {
  margin-top: var(--base-size-48);
}

.FAQ.details__summary {
  font-weight: var(--brand-text-weight-normal);
  font-size: var(--brand-text-size-800);
  line-height: var(--brand-text-lineHeight-800);
  letter-spacing: var(--brand-text-letterSpacing-800);
  color: var(--brand-FAQ-color-heading);
  cursor: pointer;
  outline: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
}

@media screen and (min-width: 48rem) {
  .FAQ__content-wrapper--gridline,
  .FAQ__heading-wrapper--gridline {
    padding-inline: var(--base-size-36);
  }
}

@media screen and (min-width: 63.25rem) {
  .FAQ__content-wrapper--gridline,
  .FAQ__heading-wrapper--gridline {
    padding-inline: 0;
  }

  .FAQ__heading-wrapper--gridline {
    margin-block-end: var(--base-size-48);
  }

  .FAQ--variant-gridline {
    padding-block-end: var(--base-size-64);
  }
}
